import 'react-app-polyfill/ie9';
import { render } from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import AOS from 'aos';
import 'aos/dist/aos.css';
// import 'react-select/dist/react-select.css';
// import 'sanitize.css/sanitize.css';

import store, { history } from './store';
import App from './containers/app';

import './index.scss';

AOS.init({
  delay: 0,
  duration: 300
});

const target = document.querySelector('#root');

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  target
);
